// web/src/components/LocationsDisplay.tsx
import React from "react";
import { Shape, shapeSvgMap } from "../utils";
import {
  LocationInfo,
  LocationInfo_Type,
} from "../api/copenhunt/v1/copenhunt_pb";
import "./TeamsDisplay.css";

interface LocationsDisplayProps {
  locations: LocationInfo[];
  objectiveShapes: Record<string, Shape>;
  onDeleteLocation: (locationId: string) => void;
}

const LocationsDisplay: React.FC<LocationsDisplayProps> = ({
  locations,
  objectiveShapes,
  onDeleteLocation,
}) => {
  return (
    <div>
      {locations.length > 0 && (
        <>
          <h3>Locations</h3>
          <ul>
            {locations.map((loc) => (
              <li key={loc.id} style={{ marginBottom: 8 }}>
                <strong>{LocationInfo_Type[loc.type]}</strong>{" "}
                {loc.type === LocationInfo_Type.BANK ||
                loc.type === LocationInfo_Type.HUNTING_GROUNDS ? (
                  loc.id
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    width="24"
                    height="24"
                    dangerouslySetInnerHTML={{
                      __html: `<g transform="scale(1.5)">${
                        shapeSvgMap[objectiveShapes[loc.id]]
                      }</g>`,
                    }}
                  />
                )}
                <button
                  className="remove-button-small"
                  onClick={() => onDeleteLocation(loc.id)}
                >
                  &times;
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default LocationsDisplay;
